import React from 'react';
import { VALID_GAME_ID } from '@root/constants';
import styles from './InvalidGameIdScreen.module.scss';

const InvalidGameIdScreen: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.logoPlaceholder} />
    <div className={styles.heading}>Invalid Game ID</div>
    <div className={styles.subtext}>
      This application is for Ludo Last Mile game only (ID: {VALID_GAME_ID})
    </div>
  </div>
);

export default InvalidGameIdScreen;
